export default {
  functionKey: "CONTIENT",
  title: "CONTIENT",
  group: "Organisation",
  origin: [],
  arguments: [],
  target: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Text", name: "Recherche" }],
  expectedArguments: [
    { name: "Recherche", argumentKey: "Text", single: true, initialValue: "" }
  ],
  description: "Evalue si le texte d'origine contient le texte de l'argument",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.includes(${args[0]});`;
    return { displayCode: code, safeCode: code };
  }
}
